export const fetchMemorial = 'FETCH_MEMORIAL';
export const fetchAuthor = 'FETCH_AUTHOR';
export const fetchDiscover = 'FETCH_DISCOVER';
export const fetchResearch = 'FETCH_RESEARCH';
export const fetchMaterial = 'FETCH_MATERIAL';
export const fetchPage = 'FETCH_PAGE';

export const levels = {
  discover: 'discover',
  research: 'research',
  material: 'material'
};
